import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";


const PaymentFailure = () => {

    const navigate = useNavigate();
    const [redirectCounter, setRedirectingCounter] = useState(5)

    useEffect(() => {
        const interval = setInterval(() => {
            setRedirectingCounter((prevCount) => {
            if (prevCount > 0) {
              return prevCount - 1;
            } else {
              clearInterval(interval)
              return prevCount;
            }
          });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (redirectCounter < 1) {
            navigate('/')
        }
    }, [redirectCounter])

    return (
        <div className="w-screen h-screen bg-[#13181E] flex items-center justify-center">
            <div className="w-[80%] md:w-[37%] p-4 md:p-8 bg-[#192738] rounded-md flex flex-col justify-center items-center">
                <div className="w-[90%] md:w-[80%] flex justify-center items-center text-[#FEC330] text-[24px] md:text-[32px] font-inter font-medium leading-[120%] text-center">
                    {`Payment Failed!`}
                </div>
                <div className="mt-12 w-[90%] md:w-[80%] flex justify-center items-center text-[#FEC330] text-[10px] md:text-[16px] font-inter leading-[120%] text-center opacity-70">
                    {`Redirecting in ${redirectCounter} seconds...`}
                </div>
            </div>
        </div>
    )
}

export default PaymentFailure
